module.exports = __webpack_public_path__ + "media/src/images/icons/chevron-up-b800c053918906fc43b6513020d32df2.svg";